module.exports = __webpack_public_path__ + "ng.svg?ba3bb51aca71f876f6d55d8ea53f7a73";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/ng.svg
// module id = 1536
// module chunks = 0